import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import styled from 'styled-components';

import {
  BigSliderProps,
  DetailedCarGalleryImageItem,
} from '@/components/DetailedCarGallery/DetailedCarGallery.types';
import {
  Component,
  Slide,
  StyledPicture,
} from '@/components/DetailedCarGallery/components/BigSlider/BigSlider';
import { colors } from '@/constants/theme';

function MobileSlider({
  images,
  currentSlideIndex,
  setCurrentSlideIndex,
  alt,
  onClick,
  setSwiper,
}: BigSliderProps) {
  const getCurrentSlideIndex = () => {
    if (currentSlideIndex > images.length) {
      return 1;
    } else if (currentSlideIndex === 0) {
      return images.length;
    } else {
      return currentSlideIndex;
    }
  };

  return (
    <Component>
      <Swiper
        onSwiper={setSwiper}
        loop={true}
        allowTouchMove={images?.length > 1}
        initialSlide={currentSlideIndex - 1}
        onSlideChange={(swiper) => setCurrentSlideIndex(swiper.activeIndex)}
      >
        {images.map((item: DetailedCarGalleryImageItem, index) => (
          <SwiperSlide key={index}>
            <Slide onClick={onClick}>
              <StyledPicture
                mobileLarge={{ src: item.mobile }}
                mobileSmall={{ src: item.mobile }}
                loading="lazy"
                alt={`${alt ?? 'detailed car image'} #${index + 1}`}
              />
            </Slide>
          </SwiperSlide>
        ))}
      </Swiper>
      <SlideCounter>
        {getCurrentSlideIndex()} / {images.length}
      </SlideCounter>
    </Component>
  );
}

const SlideCounter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 3;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.65);
  color: ${colors.white};
  text-align: center;
  border-radius: 8px;
  font-weight: 500;
  font-size: 12px;
  line-height: 11px;
  padding: 5px;
  margin: 10px 20px;
`;

export default MobileSlider;
